<template>
  <div class="buy-confirm" :class="{ hasStudent }">
    <!-- 收货地址 -->
    <AddressItem v-if="!!hasAddress"></AddressItem>

    <!-- 商品信息 -->
    <ProductInfo
      v-if="confirmProduct.skuInfo && !isTripTicket602"
      :isCustomisedGoods="isCustomisedGoods"
      :product="confirmProduct.skuInfo"
      :priceInfo="confirmProduct.priceInfo"
    ></ProductInfo>

    <!--门票601模板展示价格日历-->
    <!-- <div
      class="trip-date-wrap"
      v-show="isTripTicket601 && availDatePrice.length"
    > -->
    <!-- <div class="trip-date-wrap" v-if="isTripTicket601"> -->
    <!-- 携程景区信息 -->
    <ThirdProductInfo
      v-if="isTripTicket602 && skuInfo"
      :product="confirmProduct.skuInfo"
      :spotInfo="confirmProduct.spotInfo"
      :isIdCard="schemeTravPerson ? true : false"
      :availDatePrice="availDatePrice"
      :pkgs="pkgs"
      @useTripDate="useTripDate"
    >
      <template v-if="skuInfo.minQuantity && skuInfo.maxQuantity">
        <div class="pkgs-wrap-602">
          <i
            class="btn-less"
            :class="{ avail: pkgs > skuInfo.minQuantity }"
            @click="pkgsLess(skuInfo.minQuantity)"
          ></i>
          <span class="pkgs-pcs">{{ pkgs }}</span>
          <i
            class="btn-more"
            :class="{
              avail:
                skuInfo &&
                !hasUserMatch &&
                skuInfo.maxQuantity > 0 &&
                pkgs < skuInfo.maxQuantity
            }"
            @click="pkgsMore(skuInfo.maxQuantity)"
          ></i>
        </div>
      </template>
    </ThirdProductInfo>

    <div
      class="trip-date-wrap"
      v-show="isTripTicket601 && skuInfo && skuInfo.isNoCalendar"
    >
      <selectTripDate
        :availDatePrice="availDatePrice"
        :isNoCalendar="skuInfo && skuInfo.isNoCalendar"
        @useTripDate="useTripDate"
      ></selectTripDate>
    </div>
    <!--购买数量-->
    <div
      class="pkgs-wrap"
      :style="{ 'margin-top': isTripTicket601 ? '-0.38rem' : '-0.6rem' }"
      v-if="isMultiAvail && !isTripTicket602"
    >
      <b class="pkgs-tit pf-medium">购买数量</b>
      <span class="pkgs-ext" v-if="false">每单最多购买5张</span>
      <span class="pkgs-ph"></span>
      <i class="btn-less" :class="{ avail: pkgs > 1 }" @click="pkgsLess(1)"></i>
      <span class="pkgs-pcs">{{ pkgs }}</span>
      <i
        class="btn-more"
        :class="{
          avail:
            skuInfo &&
            !hasUserMatch &&
            (skuInfo.purchaseTimes === 0 ||
              (skuInfo.purchaseTimes > 0 && pkgs < skuInfo.purchaseTimes))
        }"
        @click="pkgsMore(skuInfo.purchaseTimes)"
      ></i>
    </div>

    <!-- 教育品类权益卡课程套餐选择 -->
    <CoursePackage
      v-if="
        skuInfo &&
        skuInfo.coursePackage &&
        skuInfo.coursePackage.courseList &&
        skuInfo.coursePackage.courseList.length > 0
      "
      class="course-package-wrapper"
      :max="isChooseCourse ? optionalCourseNum : 0"
      :courses="skuInfo.coursePackage.courseList"
      :selectedCourses.sync="selectCourses"
    />

    <!-- 适用门店 -->
    <SuitableStore
      v-if="!!hasPopStore"
      :sku-tags="[skuTag]"
      @onStoreSelected="onStoreSelected"
      @onStoreChanged="onStoreChanged"
      :title-from="'确认订单'"
      :isOpenReplacement="isCustomisedGoods"
      :isCustomisedGoods="isCustomisedGoods"
      :isSelfPhoto="isSelfPhoto"
      :parentSpuId="parentSpuId"
      :businessKey="businessId"
    />

    <!-- 套餐项目 -->
    <Combo
      v-if="skuInfo && skuInfo.spuPackageItemDomain"
      class="combo-wrap"
      :optionalCombos="optionalCombos"
      :requiredCombosNum="requiredCombosNum"
      :selectedCombos.sync="selectedCombos"
    >
    </Combo>

    <!--配置表单-->
    <div v-if="!!hasCollection">
      <section v-for="(group, index) in schemeOut" :key="index">
        <wrapper
          :ph="true"
          :title="group.title"
          :subtitle="group.moduleId * 1 === 2 ? travPersonNumTxt : ''"
          v-if="!(group.moduleId * 1 === 2 && group.fields[0].num === 0)"
        >
          <div
            v-for="(field, index) in group.fields"
            :is="field.comp"
            :key="field.fid"
            :fid="field.fid"
            :type="field.type"
            :fkey="field.key"
            :label="field.label"
            :maxlength="field.maxlength"
            :isRequired="field.isRequired"
            :regexp="field.regexp"
            :placeholder="field.placeholder"
            :options="field.options"
            v-model="field.val"
            :bb="index < group.fields.length - 1"
            :pr="true"
          ></div>
        </wrapper>
      </section>
    </div>

    <div
      v-if="resourceOrderExtendInfoList.length > 0"
      class="ticket602-wrapper"
    >
      <div v-for="(group, index) in resourceOrderExtendInfoList" :key="index">
        <p>{{ group.title }}</p>
        <div
          v-for="(field, index) in group.fields"
          :is="field.comp"
          :key="field.fid"
          :fid="field.fid"
          :type="field.type"
          :fkey="field.key"
          :label="field.label"
          :maxlength="field.maxlength"
          :isRequired="field.isRequired"
          :regexp="field.regexp"
          :placeholder="field.placeholder"
          :options="field.options"
          :datas="field.datas"
          v-model="field.val"
          :bb="index < group.fields.length - 1"
          :pr="true"
        ></div>
      </div>
    </div>

    <TravPersonSelect
      v-if="schemeTravPerson"
      :personType="0"
      :supportInsurance="insuranceType > 0"
      :ph="true"
      v-model="schemeTravPerson.fields[0].val"
      :pr="true"
      :num="travPersonNum"
    >
    </TravPersonSelect>

    <TicketTakerSelect
      v-if="schemeTicketTaker"
      :personType="1"
      :supportInsurance="insuranceType > 0"
      :ph="true"
      v-model="schemeTicketTaker.fields[0].val"
      :pr="true"
      :num="1"
    >
    </TicketTakerSelect>

    <!-- 保险信息 -->
    <Insurance
      v-if="insuranceType > 0"
      style="margin-bottom: 0.2rem"
      :type="insuranceType"
    />

    <!-- 价格信息 -->
    <div style="margin-bottom: 0.2rem">
      <price-detail
        :spuId="spuId"
        :skuId="skuId"
        :level4CategoryId="level4CategoryId"
        :businessId="businessId"
        :isAllPayType="isAllPayType"
        :buyNum="pkgs"
        :tripCalendar="tripCalendar"
        :isNoCalendar="skuInfo && skuInfo.isNoCalendar"
        :hasUserMatch="hasUserMatch"
      ></price-detail>
    </div>

    <!-- 我的积分余额 -->
    <div
      v-if="
        isSupportScore && confirmProduct.userInfo && confirmProduct.priceInfo
      "
      class="my-points"
    >
      <div class="name">我的积分余额</div>
      <div class="value pf-simbold" :class="{ gray: isLessScore }">
        {{ confirmProduct.userInfo.userPoints }}积分
        <template v-if="isLessScore">，积分不足 </template>
      </div>
    </div>

    <!-- 定金尾款 -->
    <div style="margin-bottom: 0.2rem" v-if="!isAllPayType">
      <pay-period :product="confirmProduct"> </pay-period>
    </div>

    <!-- 培训人员 -->
    <Student v-if="!!hasStudent" :studentInfo="studentInfo"></Student>

    <!-- 服务信息 -->
    <serve :fillIn="fillIn"></serve>

    <!-- 全款购买 -->
    <div class="all-pay" v-if="isPayPeriod">
      <span>使用全款购买</span>
      <mt-switch v-model="isAllPay" @change="onChanged"></mt-switch>
    </div>

    <!-- 不要删除-->
    <div class="menu_wkBox_back_box"></div>

    <!-- 底部工具栏 -->
    <actions
      :product="confirmProduct"
      :studentInfo="studentInfo"
      :fillIn="fillIn"
      :isPos="isPos"
      :newStoreInfo="newStoreInfo"
      :isCustomisedGoods="isCustomisedGoods"
      :isSelfPhoto="isSelfPhoto"
      :isAllPayType="isAllPayType"
      :buyNum="pkgs"
      :pickUp="pickUpAddress"
      :schemeOut="schemeOut"
      :tripCalendar="tripCalendar"
      :isNoCalendar="skuInfo && skuInfo.isNoCalendar"
      :schemeTravPerson="schemeTravPerson"
      :schemeTicketTaker="schemeTicketTaker"
      :hasAddress="hasAddress"
      :selectedCombos="selectedCombos"
      :requiredCombosNum="requiredCombosNum"
      :isChooseCourse="isChooseCourse"
      :optionalCourseNum="optionalCourseNum"
      :selectCourses="selectCourses"
      :thirdInfos="resourceOrderExtendInfoList"
      :spotId="spotId"
      :supportInsurance="insuranceType > 0"
      :insuranceType="insuranceType"
    ></actions>

    <!-- 分享 -->
    <pageAction
      v-if="viewName.length > 0"
      :viewName="viewName"
      :params="{ ShareCode: shareCode || '' }"
    ></pageAction>
  </div>
</template>

<script>
import { Switch } from 'mint-ui'
import { Msgbox } from 'kf-component-vue'
import { mapState, mapMutations } from 'vuex'
import { SKUTAG } from '@/plugins/enum'
import ProductInfo from '../product-info'
import ThirdProductInfo from '../product-info/thirdProductInfo.vue'
import Combo from '@/components/confirm/combo'
import serve from '@/components/confirm/confirmServe'
import actions from '../action'
import pageAction from '@/components/actionSheet/pageAction'
import AddressItem from '@/components/confirm/address-item'
import PriceDetail from '../price-detail'
import PayPeriod from '../pay-period'
import Student from '@/components/confirm/student'

import CoursePackage from '../course-package'
import DeliveryAddress from '../delivery-address'
import TravPersonSelect from '../select-person/selectPerson.vue'
import TicketTakerSelect from '../select-person/selectPerson.vue'
import Input from '../input'
import Radio from '../radio'
import CheckBox from '../multi-check'
import Wrapper from '../wrapper'
import selectTripDate from '../trip-date/selectTripDate.vue'
import { createNamespacedHelpers } from 'vuex'
import SuitableStore from '@/components/storeInfo/suitableStore/withoutImage'

import { SKUTAGNEED, RULETYPE } from '@/plugins/enum'
import { isNullOrEmpty, isTrue } from '@/utils'
import { dispatchMixPromotion } from '@/router/home/new/product.bus'
import { E_ORDER_TYPE, E_PROMOTION_TYPE } from '@/config'

import lodashMap from 'lodash/map'
import lodashConcat from 'lodash/concat'
import lodashFindIndex from 'lodash/findIndex'
import isEmpty from 'lodash/isEmpty'
import http from '@/plugins/http'

import Insurance from '../insurance/index.vue'
import { InsuranceType } from '@/config'
import { setTitle } from 'kwsdk'
const {
  mapActions,
  mapState: nameSpaceState,
  mapMutations: nameSpaceMutations
} = createNamespacedHelpers('insurance')
function refreshUrl(keys, url) {
  let search = window.location.search
  search = search.substring(1)
  let newUrl = ''
  let url_arr = []
  if (keys && search !== '') {
    const search_arr = search.split('&')
    const set_search = new Set(search_arr)
    const set_keys = new Set(keys)
    const differenceABSet = new Set(
      [...set_search].filter(x => !set_keys.has(x.split('=')[0]))
    )
    url_arr = Array.from(differenceABSet)
  }
  newUrl = `${window.location.origin + window.location.pathname}${
    url_arr.length > 0 ? `?${url_arr.join('&')}` : ''
  }`
  return newUrl
}
export default {
  inject: ['reload'],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const u = location.href
      if (u.indexOf('action') > -1) {
        location.replace(refreshUrl(['action', 'viewName']))
      }
      // vm.$store.commit('changeView', 'address')
      vm.$store.commit('hideActionSheet')
    })
  },
  data() {
    const {
      query: {
        isCustomisedGoods: isCustomed,
        parentSpuId,
        businessKey: businessId = '',
        skuId = '',
        ruleType = E_ORDER_TYPE.POSITIVE_PRICE,
        ruleId = '',
        address_id = '',
        order_time = '',
        prid,
        empId = '',
        spotId = ''
      },
      params: { spuId }
    } = this.$route
    return {
      spuId,
      skuId,
      spotId,
      ruleId, // 订单类型为2,3,4,5时必填
      ruleType, // 订单类型1、系统下单 2、一元购下单 3、抢购下单 4、团购下单 5、积分下单", //必填
      //staff_id: -1,
      address_id,
      order_time,
      address: '',
      uid: '',
      skey: '',
      // ShareCode: '',
      empId,
      prid,
      isPos: false,
      fillIn: {
        inviteCode: '', //邀请码
        remark: '' // 备注
      },
      studentInfo: {
        // studentName:'', //学员姓名, 后台传入的key名称
        // studentMobile:'', //学员手机号  后台传入的key名称
        isReaded: false // 是否已阅读
      },
      newStoreInfo: null,
      isCustomisedGoods: isTrue(isCustomed),
      parentSpuId,
      businessId,
      level4CategoryId: '',
      isAllPay: true,
      pkgs: 1, // 购买数量
      pickUpAddress: null, //自提门店
      schemeOut: [], //配置表单
      schemeMailAddress: null, //配置的收货地址
      availDatePrice: [], //价格日历
      tripCalendar: null, //选中的日期
      schemeTravPerson: null, //出行人,
      schemeTicketTaker: null, //出行人,
      changeBuyNumTrackParams: null,
      selectedCombos: [], //已选套餐项目
      selectCourses: [], //已选教育套餐
      insuranceType: InsuranceType.NONE
    }
  },
  provide() {
    const pageParam = {
      skuid: this.skuId,
      popid: this.businessId,
      skutype: this.skuTag
    }
    return {
      /* 点击促销立减按钮埋点参数 */
      reducePriceTrackParams: {
        bizType: '127',
        pageLevelId: '121013095',
        pageParam: pageParam,
        clickId: '200007',
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      },
      /* 点击切换优惠券模块埋点参数 */
      changeCouponTrackParams: {
        bizType: '127',
        pageLevelId: '121013095',
        pageParam: pageParam,
        clickId: '200006',
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      },
      /* 点击切换地址埋点参数 */
      changeAddrTrackParams: {
        bizType: '127',
        pageLevelId: '121013095',
        pageParam: pageParam,
        clickId: '200005',
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      },
      /* 点击提交订单按钮埋点参数 */
      submitTrackParams: {
        bizType: '127',
        pageLevelId: '121013095',
        pageParam: pageParam,
        clickId: '200004',
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      },
      /* 点击切换自营服务人员埋点参数 */
      changeServiceWorkerTrackParams: {
        bizType: '127',
        pageLevelId: '121013095',
        pageParam: pageParam,
        clickId: '200002',
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      },
      /* 点击切换自营服务门店 */
      changeServicePopTrackParams: {
        bizType: '127',
        pageLevelId: '121013095',
        pageParam: pageParam,
        clickId: '200001',
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      }
    }
  },
  async created() {
    const { uid, skey } = await this.$$ensureLogin()
    this.uid = uid
    this.skey = skey
    this.trackView(undefined, {
      skuid: this.skuId
    })
    try {
      this.$$loading(true)
      this.$$title('确认订单')
      /** 重置选择 start ======防止上级页面router.push方式跳转.选择缓存命中 */
      this.$store.commit('setSelectedTime', '')
      this.$store.commit('setSelectedWorker', {})
      this.$store.commit('setWorkers', [])
      this.$store.commit('setConfirmSelected', {
        store: {},
        city: {}
      })
      this.$store.dispatch('getIsOpenAppCashier')
      /** 重置选择 end */

      if (this.prid) {
        this.$store.commit('setSelectedAddress', {
          regionid: this.prid,
          province: decodeURIComponent(this.$route.query.province),
          city: decodeURIComponent(this.$route.query.city),
          district: decodeURIComponent(this.$route.query.district)
        })
      }
      await this.getProduct()

      //携程景区限制最小购买
      if (this.isTripTicket602) {
        this.pkgs = this.skuInfo.minQuantity
        //602支持价格日历
        this.setSupportPriceCalendar(true)
      }
      if (this.isTripTicket601 && this.skuInfo && this.skuInfo.isNoCalendar) {
        //601支持价格日历的判断逻辑
        this.setSupportPriceCalendar(true)
      }
      this.insuranceType =
        (this.confirmProduct &&
          this.confirmProduct.insureInfo &&
          this.confirmProduct.insureInfo.giveInsure) ||
        InsuranceType.NONE
      //初始化
      if (this.insuranceType === InsuranceType.ALL) {
        //亲自家庭票 只能选2份成人保险 1份儿童保险   其他类型按照购买数量
        this.setTravelChildPersonNum(1)
        this.setTravelAdultPersonNum(2)
      }

      this.setData()

      this.getPromotionInfo()

      const showInsurance = this.insuranceType > 0 //是否显示保险
      if (showInsurance) {
        this.getCmsConfig4Insurance()
      }
      if (!this.schemeTravPerson && !this.schemeTicketTaker && showInsurance) {
        this.getTravelPersonList({ vm: this, isCommit: true })
      }

      // this.getCouponConfirm()

      this.$$loading(false)

      const { address_id } = this
      /*************  获取用户地址 start   ****************/
      // const address_id = this.address_id
      if (address_id !== 999999 && uid && skey && this.hasAddress) {
        // 地址未匹配到 有地址选项
        // 获取用户地址
        const queryAddr = this.$$queryString.stringify({
          uid,
          skey,
          addrtype: 0
        })
        await this.$store.dispatch('getUserAddress', {
          query: queryAddr,
          addrid: address_id
        })
      }
      /*************  获取用户地址 end   ****************/
      /*************  获取服务人员 start   ****************/
      // 如果有地址属性并获取到默认地址，然后获取服务人员
      if (
        this.hasAddress &&
        this.selectedAddress.regionid &&
        this.selectedAddress.regionid !== ''
      ) {
        const areaCode = this.selectedAddress.regionid.split('_')[2]
        if (areaCode !== '' && this.hasWorker) {
          //有服务人员选项
          await this.$store.dispatch('getWorkers', {
            spuId: this.spuId,
            serviceDate: this.order_time,
            districtId: areaCode
          })
        }
      }

      /*************  获取服务人员 end   ****************/

      //初始化服务人员信息
      if (this.hasWorker) {
        if (this.shareCode || this.empId) {
          // 存在推荐的人或者从主页进入服务
          const code = this.shareCode || this.empId
          const availableWorkers =
            (this.workers.available && this.workers.available.workerList) || []
          const use_rec = availableWorkers.filter(
            ele => ele.workerCode === code
          )
          if (use_rec.length > 0) {
            this.$store.commit('setSelectedWorker', use_rec[0] || {})
          }
        }
      }

      const code =
        this.confirmProduct.shareDetail &&
        this.confirmProduct.shareDetail.shareCode
      this.fillIn.inviteCode = code || ''
    } catch (e) {
      console.error(e)
      if (e.message === '1024' || e.message === '4') {
        this.$$login()
      }
    }

    /* 点击购买数量埋点参数 */
    this.changeBuyNumTrackParams = {
      bizType: '127',
      pageLevelId: '121013095',
      pageParam: {
        skuid: this.skuId,
        popid: this.businessId,
        skutype: this.skuTag
      },
      clickId: '200003',
      positionParam: {
        fuid: this.$$cookie('uid')
      }
    }

    this.$$newTrackView({
      bizType: '127',
      pageLevelId: '121013095',
      pageParam: {
        skuid: this.skuId,
        popid: this.businessId,
        skutype: this.skuTag,
        categoryid: this.skuInfo?.level4CategoryId
      }
    })
  },
  mounted() {
    const compname = this.$route.query.viewName
    if (compname) {
      this.changeView(this.$route.query.viewName)
    }
  },
  methods: {
    ...mapActions(['getCmsConfig4Insurance', 'getTravelPersonList']),
    ...nameSpaceMutations([
      'setSupportPriceCalendar',
      'setSelectPriceCalendarDate',
      'setTravelAdultPersonNum',
      'setTravelChildPersonNum',
      'setSchemeTravPerson',
      'setSchemeTicketTaker'
    ]),
    ...mapMutations(['changeView', 'setIsSupportScore']),
    pkgsLess(min) {
      if (this.pkgs > min) {
        this.pkgs--
        console.log(
          'this.changeBuyNumTrackParams :>> ',
          this.changeBuyNumTrackParams
        )
        this.changeBuyNumTrackParams &&
          this.$$newTrackClick(this.changeBuyNumTrackParams)
      }
    },
    pkgsMore(max) {
      if (this.hasUserMatch) return
      let origin = this.pkgs
      let result = origin + 1
      if (max > 0 && result > max) {
        this.$$toast(`已达到购买上限`)
      } else {
        this.pkgs++
      }
      this.changeBuyNumTrackParams &&
        this.$$newTrackClick(this.changeBuyNumTrackParams)
    },
    onChanged(checked) {
      if (checked) {
        window.scrollTo(0, document.body.scrollHeight)
      }
    },

    async setData() {
      const {
        skuInfo: { businessId, skuId, level4CategoryId },
        collectInfo,
        priceInfo
      } = this.confirmProduct
      this.businessId = businessId
      this.skuId = skuId
      this.level4CategoryId = level4CategoryId

      this.setIsSupportScore(
        this.$route.query.payMethod == 'point' &&
          priceInfo &&
          priceInfo.payScore != null
      )

      if (this.hasCollection) {
        //配置信息
        this.setSmartFormScheme(collectInfo)
      }

      if (this.isTripTicket601 || this.isTripTicket602) {
        this.availDatePrice = await this.fetchTripCalendar(this.skuId)
      }
    },
    async fetchTripCalendar(skuId) {
      const url =
        '//sccapi.cekid.com/scc-api/api/admissionTicket/queryAdmissionTicketPrice.do'
      const res = await http.get(url, {
        skuId,
        uid: this.$$cookie('uid') || '',
        skey: this.$$cookie('skey') || ''
      })
      return res.data
    },
    useTripDate(date) {
      this.tripCalendar = date
      this.setSelectPriceCalendarDate(
        new Date(date.year, date.month - 1, date.date)
      )
      console.log('useTripDate:', date)
    },
    getPromotionInfo() {
      //一元购不走促销
      if (+this.ruleType !== E_ORDER_TYPE.ONE_YUAN_PURCHASE) {
        // 获取营销活动信息
        dispatchMixPromotion(this)
      }
    },
    async getProduct() {
      try {
        const {
          uid,
          skey,
          skuId,
          spotId,
          ruleType: channelType,
          ruleId: activityId
        } = this
        const query = {
          uid,
          skey,
          skuId,
          channelType,
          activityId,
          spotId
        }

        if (this.$route.query.payMethod == 'point') {
          query.blessPayType = 1
        }
        // const hserecomkey = this.$route.query.hserecomkey || this.$$cookie('hserecomkey') || ''
        // if (hserecomkey && hserecomkey !== '') {
        //     query.shareKey = shareKey
        // }

        const shareKeyObj =
          this.$route.query.hserecomkey || this.$$cookie('hserecomkey') || ''
        let shareKey = shareKeyObj
        if (shareKeyObj instanceof Array) {
          const newShareObj = shareKeyObj.filter(v => v)
          if (newShareObj && newShareObj.length > 0) {
            shareKey = newShareObj[newShareObj.length - 1]
          }
        } else if (isNullOrEmpty(shareKeyObj)) {
          shareKey = ''
        }
        if (shareKey && shareKey !== '') {
          query.shareKey = shareKey
        }
        const queryString = JSON.stringify(query)
        const res = await this.$store.dispatch('getConfirmProduct', queryString)
        if (res.code === '4') {
          this.$$login()
        } else if (res.code !== '1') {
          /* 订单确认校验斑马 */
          if (res.code == '200') {
            Msgbox({
              message: res.msg
            })
          } else {
            this.$$toast(res.msg)
          }
        }
      } catch (e) {
        return false
      }
    },
    onStoreSelected(storeInfo) {
      this.newStoreInfo = storeInfo
      /**
       * 在商品详情页定制SKU门店获取门店API请求未完毕之前，点击购买跳转至订单确认页
       * 而在订单确认页同样有门店模块，此时门店信息已处理完毕，门店模块正确加载
       * 然而此时页面展示的信息仍然是原sku的订单，信息错误
       * 需要更改相关数据并reload
       */
      let {
        query: { beforeMLoaded } // isSubmitBeforeStoreModuleLoaded
      } = this.$route
      if (this.isCustomisedGoods && beforeMLoaded) {
        this.onStoreChanged(storeInfo, false)
      }
    },
    onStoreChanged(storeInfo, useTimeout = true) {
      const { skuId = this.skuId, spuId, businessKey } = storeInfo
      // 重写mixin方法
      this.$$loading(true)
      const func = () => {
        let { name, params, query, meta, path } = this.$route
        delete this.$route.query._m
        delete this.$route.query.beforeMLoaded
        path = path.replace(/\d+/, spuId)
        this.$router.replace({
          path,
          name,
          params: {
            ...params,
            spuId
          },
          query: {
            ...query,
            skuId,
            businessKey,
            _m: Math.random().toString().substr(2)
          },
          meta
        })
        // 商品更换后，刷新页面
        this.reload()
      }
      if (useTimeout) {
        func()
      } else {
        // 加个延时 等待上一步history.go(-1)执行完毕
        setTimeout(func, 1500)
      }
    },
    smartFromSchemeMix(scheme) {
      return lodashMap(scheme, (v, k, a) => {
        // 通用表单
        if (k === 'custom') {
          return v
        }
        // 定制表单
        const { title, moduleId, reqParam, ...ext } = v
        return [
          {
            title,
            moduleId,
            fields: [
              {
                regularTip: '',
                maxlength: '',
                labelType: k,
                isRequire: '',
                placeholder: '',
                labelName: '',
                labelKey: '',
                labelTypeValue: '',
                regular: '',
                fieldId: '',
                reqParam,
                ext
              }
            ]
          }
        ]
      })
    },
    smartFromSchemeNormalize(scheme) {
      return lodashConcat(...scheme).map((o, i, a) => ({
        title: o.title,
        moduleId: o.moduleId,
        fields: o.fields.map((oo, ii, aa) => ({
          fid: oo.fieldId,
          type: oo.labelType,
          key: oo.labelKey,
          val:
            o.moduleId * 1 === 1 &&
            oo.ext.defaultDeliveryAddr &&
            !isEmpty(oo.ext.defaultDeliveryAddr)
              ? oo.ext.defaultDeliveryAddr
              : undefined, // HACK: 通过蹩脚的方法插入一个参数
          label: oo.labelName || undefined,
          maxlength: oo.maxlength,
          isRequired: oo.isRequire,
          regexp: oo.regular,
          regtip: oo.regularTip,
          placeholder: oo.placeholder || undefined,
          options: oo.options,
          comp: this.field2comp(oo.labelType)
        }))
      }))
    },
    smartFormExtract(scheme, moduleName) {
      // 收货地址单独抽出放到页面顶部
      const idx = lodashFindIndex(scheme, o => {
        const idx = lodashFindIndex(o.fields, oo => oo.comp === moduleName)
        return idx !== -1
      })
      return idx === -1 ? null : scheme.splice(idx, 1)[0]
    },
    setSmartFormScheme(collectInfo) {
      const schemeIn = collectInfo || []
      const schemeTmp = this.smartFromSchemeMix(schemeIn)
      const schemeNml = this.smartFromSchemeNormalize(schemeTmp)
      this.schemeMailAddress = this.smartFormExtract(
        schemeNml,
        'cellMailAddress'
      )

      this.schemeTravPerson = this.smartFormExtract(
        schemeNml,
        'TravPersonSelect'
      )
      //将出行人放入store 供保险使用
      this.setSchemeTravPerson(this.schemeTravPerson)

      this.schemeTicketTaker = this.smartFormExtract(
        schemeNml,
        'TicketTakerSelect'
      )

      //将取票人放入store 供保险使用
      this.setSchemeTicketTaker(this.schemeTicketTaker)

      this.pickUpAddress = this.smartFormExtract(schemeNml, 'DeliveryAddress') //自提地址
      this.schemeOut = schemeNml
    },
    smartFromSchemeNormalize(scheme) {
      return lodashConcat(...scheme).map((o, i, a) => ({
        title: o.title,
        moduleId: o.moduleId,
        fields: o.fields.map((oo, ii, aa) => ({
          fid: oo.fieldId,
          type: oo.labelType,
          key: oo.labelKey,
          val:
            o.moduleId * 1 === 1 &&
            oo.ext.defaultDeliveryAddr &&
            !isEmpty(oo.ext.defaultDeliveryAddr)
              ? oo.ext.defaultDeliveryAddr
              : undefined, // HACK: 通过蹩脚的方法插入一个参数
          label: oo.labelName || undefined,
          maxlength: oo.maxlength,
          isRequired: oo.isRequire,
          regexp: oo.regular,
          regtip: oo.regularTip,
          placeholder: oo.placeholder || undefined,
          options: oo.options,
          comp: this.field2comp(oo.labelType)
          // tpid: oo.tpid,
          // id: oo.tpid
        }))
      }))
    },
    field2comp(arg) {
      let comp
      switch (arg) {
        case 'inputtext':
          comp = 'Input'
          break
        case 'deliveryAddr':
          comp = 'cellMailAddress'
          break
        case 'travelPerson':
          comp = 'TravPersonSelect'
          break
        case 'realNameTicketor':
          comp = 'TicketTakerSelect'
          break
        case 'pickUp': //自提
          comp = 'DeliveryAddress'
          break
        default:
          comp = ''
      }
      return comp
    }
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.viewName === 'confirmAddress') {
          setTitle('选择地址')
        } else if (this.$route.query.viewName === 'addUserForInsurance') {
          setTitle('确认领取人信息')
        } else if (!this.$route.query.viewName) {
          setTitle('确认订单')
        }
      }
    },
    pkgs: {
      handler(val) {
        if (this.insuranceType === InsuranceType.ADULT) {
          this.setTravelAdultPersonNum(val)
        } else if (this.insuranceType === InsuranceType.CHILD) {
          this.setTravelChildPersonNum(val)
        }
      }
    }
  },
  computed: {
    ...nameSpaceState(['insuranceInfo']),
    ...mapState([
      'confirmProduct',
      'workers',
      'viewName',
      'selectedWorker',
      'selectedAddress',
      'selectedTime',
      'isSupportScore',
      'isLessScore'
    ]),
    skuInfo() {
      if (this.confirmProduct && this.confirmProduct.skuInfo) {
        return this.confirmProduct.skuInfo
      }
      return null
    },
    //携程需要的额外数据 动态
    resourceOrderExtendInfoList() {
      if (
        this.confirmProduct &&
        this.confirmProduct.ResourceOrderExtendInfoList
      ) {
        return this.confirmProduct.ResourceOrderExtendInfoList.map(item => {
          const {
            orderExtendInfoName,
            type,
            resourceOrderExtendInfoItemList,
            resourceOrderExtendInfoID
          } = item
          return {
            title: orderExtendInfoName,
            fields: [
              {
                comp:
                  type === 1 || type === 3
                    ? 'Radio'
                    : type === 2
                    ? 'CheckBox'
                    : 'Input',
                isRequired: 1,
                requestParams: val => {
                  if (type === 1 || type === 3) {
                    if (!val) {
                      return `请选择${orderExtendInfoName}`
                    }
                    return {
                      ResourceOrderExtendInfoID: resourceOrderExtendInfoID,
                      orderExtendInfoName,
                      type,
                      AddInfoDetails: [
                        {
                          ID: val.resourceOrderExtendInfoItemID,
                          Content: val.content
                        }
                      ]
                    }
                  } else if (type === 2) {
                    if (!val || val.length === 0) {
                      return `请选择${orderExtendInfoName}`
                    }
                    return {
                      ResourceOrderExtendInfoID: resourceOrderExtendInfoID,
                      orderExtendInfoName,
                      type,
                      AddInfoDetails: val.map(x => {
                        return {
                          ID: x.resourceOrderExtendInfoItemID,
                          Content: x.content
                        }
                      })
                    }
                  } else {
                    if (!val) {
                      return `请输入${orderExtendInfoName}`
                    }
                    return {
                      ResourceOrderExtendInfoID: resourceOrderExtendInfoID,
                      orderExtendInfoName,
                      type,
                      AddInfoDetails: [
                        {
                          ID: 0,
                          Content: val
                        }
                      ]
                    }
                  }
                },
                label: orderExtendInfoName,
                datas: resourceOrderExtendInfoItemList,
                placeholder: `请输入${orderExtendInfoName}`,
                val: ''
              }
            ]
          }
        })
      }
      return []
    },
    isYuesao() {
      return (
        this.skuInfo &&
        (this.skuInfo.skuSecType === 401 || this.skuTag === SKUTAG.POPYUSAO)
      )
    },
    isSelfPhoto() {
      return this.confirmProduct && this.confirmProduct.isSelfPhoto == 1
    },
    //是否符合福袋领取条件
    hasUserMatch() {
      return (
        this.confirmProduct &&
        (this.confirmProduct.hasUserMatch == 1 ||
          this.confirmProduct.hasUserMatch == 2)
      )
    },
    isTripTicket601() {
      return (
        this.skuInfo &&
        this.skuTag === SKUTAG.TICKET &&
        this.skuInfo.skuSecType === 601
      )
    },
    isTripTicketUn601() {
      return (
        this.skuInfo &&
        this.skuTag === SKUTAG.TICKET &&
        this.skuInfo.skuSecType !== 601
      )
    },
    isTripTicket602() {
      return (
        this.skuInfo &&
        this.skuTag === SKUTAG.TICKET &&
        this.skuInfo.skuSecType === 602
      )
    },
    //套票 <==== 出行人多个的门票
    isTicketPackage() {
      return (
        this.skuInfo &&
        this.skuInfo.skuSecType * 1 === 601 &&
        this.skuInfo.travelNum &&
        this.skuInfo.travelNum * 1 > 1
      )
    },
    isApplianceWash() {
      return this.skuInfo && this.skuTag === SKUTAG.APPLIANCE_WASHING
    },
    isMultiAvail() {
      // 非定金尾款 非月嫂和非多个出行人的门票且购买次数不等于1
      return (
        !this.isPayPeriod &&
        this.skuInfo &&
        !this.isYuesao &&
        this.skuInfo.purchaseTimes !== 1 &&
        !this.isTicketPackage &&
        !this.isApplianceWash
      )
    },
    travPersonNum() {
      if (this.skuInfo && this.skuInfo.travelPeopleShowType === 1) {
        return 1
      }

      let travelNum = 0
      if (this.skuInfo && this.skuInfo.travelNum) {
        travelNum = this.skuInfo.travelNum
      }
      return travelNum * this.pkgs
    },
    travPersonNumTxt() {
      const group = this.schemeTravPerson
      let n = 0
      if (group && group.fields && group.fields[0] && group.fields[0].val) {
        const val = group.fields[0].val
        if (val instanceof Array) {
          n = val.length
        }
      }
      if (this.travPersonNum) {
        return `(${n}/${this.travPersonNum})`
      }
      return ''
    },
    //自提店铺id集合 '1,2,3':string
    pickUpPoint() {
      return this.pickUpAddress && this.skuInfo ? this.skuInfo.pickUpPoint : ''
    },
    shareCode() {
      const code =
        this.confirmProduct.shareDetail &&
        this.confirmProduct.shareDetail.shareCode
      return code
    },
    skuTag() {
      return (
        this.confirmProduct &&
        this.confirmProduct.skuInfo &&
        this.confirmProduct.skuInfo.skuTag
      )
    },
    hasAddress() {
      if (
        this.skuTag === SKUTAG.ONLINE ||
        this.skuTag === SKUTAG.TICKET ||
        this.skuTag === SKUTAG.STORE_SPECIAL
      ) {
        //在线教育、门票、到店特殊的收货地址根据配置来
        if (this.schemeMailAddress) {
          const temp = ![301, 302].find(_ => _ === this.skuInfo.skuSecType)
          return temp
        }
      }
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].address
    },
    hasStudent() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].student
    },
    hasWorker() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].worker
    },
    hasTime() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].time
    },
    hasStore() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].store
    },
    hasCollection() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].collect
    },

    hasPopStore() {
      // 定制SKU商品开启更换门店功能
      if (this.isCustomisedGoods) return true
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].POP_STORE
    },
    //是否支持定金支付
    isPayPeriod() {
      return (
        !this.isSupportScore &&
        this.confirmProduct &&
        this.confirmProduct.skuInfo &&
        this.confirmProduct.skuInfo.supportPayment &&
        this.confirmProduct.skuInfo.supportPayment == 1
      )
    },
    //是否全款付款方式：付全款
    isAllPayType() {
      return this.isAllPay || !this.isPayPeriod
    },
    // 可选套餐
    optionalCombos() {
      try {
        return JSON.parse(this.skuInfo.spuPackageItemDomain.itemContent)
      } catch (error) {
        return []
      }
    },
    // 必选套餐项目数量
    requiredCombosNum() {
      return this.skuInfo && this.skuInfo.spuPackageItemDomain
        ? this.skuInfo.spuPackageItemDomain.mustChooseNum
        : 0
    },
    isChooseCourse() {
      return this.skuInfo && this.skuInfo.coursePackage
        ? this.skuInfo.coursePackage.isChooseCourse
        : 0
    },
    optionalCourseNum() {
      return this.skuInfo && this.skuInfo.coursePackage
        ? this.skuInfo.coursePackage.optionalCourseNum
        : 0
    }
  },
  components: {
    CoursePackage,
    DeliveryAddress,
    TravPersonSelect,
    TicketTakerSelect,
    ProductInfo,
    ThirdProductInfo,
    Combo,
    serve,
    actions,
    pageAction,
    'mt-switch': Switch,
    AddressItem,
    PriceDetail,
    PayPeriod,
    Student,
    SuitableStore,
    Input,
    Wrapper,
    selectTripDate,
    Radio,
    CheckBox,
    Insurance
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.buy-confirm {
  min-height: 100%;
  padding: 0 rem(24px);
  padding-top: rem(21px);
  padding-bottom: rem(119px);
  &.hasStudent {
    padding-bottom: rem(203px);
  }
  .my-points {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 rem(24px);
    height: rem(96px);
    border-radius: rem(16px);
    background: #ffffff;
    margin-bottom: rem(20px);
    .name {
      line-height: rem(32px);
      color: #262626;
      font-size: rem(26px);
    }
    .value {
      line-height: rem(32px);
      color: #262626;
      font-size: rem(26px);
      &.gray {
        color: #999999;
      }
    }
  }
  .user-remark {
    margin-top: rem(20px);
    textarea {
      display: block;
      width: 100%;
      height: rem(160px);
      font-size: rem(30px);
      padding: rem(28px) rem(20px);
      resize: none;
      appearance: none;
      border: 0 none;
    }
  }
  .invite-code {
    background-color: #fff;
    font-size: rem(28px);
    @include border(bottom);

    .iconfont {
      font-size: rem(36px);
      font-weight: 600;
    }

    input {
      width: 100%;
    }
  }
  .pos-switch {
    background-color: #fff;

    .item-cell-bd {
      display: flex;
      align-items: center;

      .item-cell-bd-title {
        flex: 1;
        color: #ff397e;
        font-size: rem(28px);
      }
    }
  }
  .all-pay {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: rem(20px);
    padding: 0 rem(24px);
    background-color: #fff;
    border-radius: rem(16px);
    height: rem(96px);
    span {
      font-size: rem(26px);
      color: #262626;
    }
  }
}
</style>
<style lang="scss">
@import '~@/assets/css/mixin';

.trip-date-wrap {
  padding: 0 rem(24px);
  background-color: #fff;
  border-radius: rem(16px);
  margin-bottom: rem(20px);
}

.pkgs-wrap-602 {
  height: rem(50px);
  display: flex;
  align-items: center;
}

.pkgs-wrap {
  height: rem(110px);
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 0 rem(24px);
  border-radius: rem(16px);
  margin: rem(-60px) 0 rem(20px) 0;
}

.pkgs-tit {
  font-size: rem(30px);
  color: #121212;
  margin-right: rem(12px);
}
.pkgs-ext {
  font-size: rem(26px);
  color: #666666;
  line-height: rem(32px);
}
.pkgs-ph {
  flex: 1;
}
.pkgs-pcs {
  font-size: rem(26px);
  color: #121212;
  min-width: rem(60px);
  text-align: center;
}
.btn-less,
.btn-more {
  width: rem(48px);
  height: rem(48px);
  background: url('~assets/images/order/pkgs.png') no-repeat left top/rem(96px)
    rem(96px);
}
.btn-less {
  background-position: left top;
  &.avail {
    background-position: right top;
  }
}
.btn-more {
  background-position: left bottom;
  &.avail {
    background-position: right bottom;
  }
}

.course-package-wrapper {
  margin-bottom: rem(20px);
  border-radius: rem(16px);
}

.ticket602-wrapper {
  background-color: #fff;
  padding: rem(25px) rem(30px) 0;
  margin-bottom: rem(20px);
  border-radius: rem(16px);
  > div p {
    background-color: #fff;
    font-size: rem(30px);
    color: #262626;
    font-weight: 500;
  }
}

.combo-wrap {
  margin-bottom: rem(20px);
}

.buy-confirm .mint-switch-input:checked + .mint-switch-core {
  border-color: #ff5900;
  background-color: #ff5900;
}
.buy-confirm {
  .label-ui {
    font-size: rem(26px);
    color: #262626;
    flex: none;
    span {
      color: #808080;
    }
  }
  .item-layout {
    padding: 0 rem(24px);
  }
  .item-common-layout {
    width: 100%;
    padding: rem(20px) 0;
    min-height: rem(76px);
    @include border(bottom, #f2f2f2, 1px);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-common-content {
    width: 100%;
    flex-direction: column;
  }
  .item-common {
    min-height: rem(76px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 rem(24px);
  }
  .icon-arr-r {
    display: inline-block;
    width: rem(44px);
    height: rem(32px);
    background: url('~@/assets/images/icon-arr-r@3x.png') no-repeat center right;
    background-size: auto rem(20px);
  }
  .item-cells {
    font-size: rem(26px);
  }
}
.kfcv-toast {
  z-index: 9999;
}
.kfcv-msgbox {
  z-index: 9990;
}
</style>
